export function groupArrayItems(arrayOfObjects, leftGroupValue) {
  const leftGroupIndex = leftGroupValue + 1;
  const leftGroupItem = arrayOfObjects.find(item => item.id === leftGroupIndex);

  if (!leftGroupItem) {
    // Handle cases where the specified value is not found in the array of objects
    return arrayOfObjects;
  }

  const rightGroup = arrayOfObjects.filter(item => item.id !== leftGroupIndex);

  return [leftGroupItem, rightGroup.length === 1 ? rightGroup[0] : rightGroup];
}



export function findMenuItem(menuItems, urlPath) {
  const pathSegments = urlPath.split('/').filter(Boolean);
  if(pathSegments.length === 0) {
    return menuItems[0];
  }
  for (let i = pathSegments.length - 1; i >= 0; i--) {
      const lastString = pathSegments[i];
      for (const item of menuItems) {
          const urlParts = item.url.split('/').filter(part => part); // Split and filter empty parts
          const lastPart = urlParts[urlParts.length - 1]; // Get the last part of the URL
          if (lastPart === lastString) {
              return item; 
          }
      }
  }
  return menuItems[0];
}




export function findMobileSubMenuItems(array, urlPath) {
  let foundItem = null;

  for (const item of array) {
    if (item.url === urlPath) {
      foundItem = item;
      break;
    } else if (urlPath.includes(item.url) && !foundItem) {
      foundItem = item;
      // break;
    }
  }

  //   if (!foundItem) {
  //     foundItem = array[0];
  // }

  return foundItem;
}




  


  